// extracted by mini-css-extract-plugin
export default {"sticky_header":"sticky_header_sticky_header__xEFoc"};